import { IcommentMention, ICommentsAndObservations } from 'types/global';
import { MENTION_TYPES } from 'types/dashboard.types';

export enum CUSTOMER_CHAT_AUTHOR_CHANNEL {
  PARTNER = 'partner',
  OPERATIONS = 'operations'
}

export interface ICustomerChatCommentImageApi {
  imageUrl?: string;
}

export interface ICustomerChatCommentApiResponse {
  id: number;
  comments: string;
  createdAt: string;
  userId: number;
  user?: string;
  authorChannel?: string | null;
  image?: ICustomerChatCommentImageApi | null;
  mentionsData?: IcommentMention[] | null;
  kamUserId?: number;
}

export interface ICustomerChatComment extends Omit<ICommentsAndObservations, 'commentImage'> {
  authorChannel?: CUSTOMER_CHAT_AUTHOR_CHANNEL | null;
}

export type TCustomerChatEntityType =
  | typeof MENTION_TYPES.ORDER
  | typeof MENTION_TYPES.LOGISTIC_SERVICE;
